import { apiRequest } from "../hooks/apiRequest";
import { toast } from "./helpers";

/**
 * Crea un registro de catálogo desde un select creatable (igual que
 * `crearUnidadConfig` para unidades) y lo devuelve como opción de react-select.
 * Devuelve null si falló; el error ya se mostró en un toast.
 */
const crearEnCatalogo = async (ruta, datos, articulo) => {
	const formData = new FormData();
	Object.entries(datos).forEach(([campo, valor]) => formData.append(campo, valor));

	const respuesta = await apiRequest(formData, ruta, "post");

	if (respuesta?.success) {
		return { value: respuesta.data.id, label: respuesta.data.nombre };
	}

	if (respuesta?.code === 422) {
		const mensajes = Object.values(respuesta?.data?.message || {}).flat();
		toast(mensajes[0] || `No se pudo crear ${articulo}.`, "error");
	} else if (respuesta) {
		toast(respuesta?.data?.message || `No se pudo crear ${articulo}.`, "error");
	}
	// Si `respuesta` es undefined, apiRequest ya mostró su propio toast de error de red.

	return null;
};

/** Los almacenes creados desde un producto son de productos (el form filtra por eso). */
export const crearAlmacen = (nombre) =>
	crearEnCatalogo("almacenes", { nombre: nombre.trim(), tipo_producto: "productos" }, "el almacén");

export const crearUbicacion = (nombre) =>
	crearEnCatalogo("ubicaciones", { nombre: nombre.trim() }, "la ubicación");

export const textoCrear = (nombre) => `Crear "${nombre}"`;
